
const setActiveSidebar = (state, activeSidebar) => {
  state.activeSidebar = activeSidebar
  localStorage.setItem('activeSidebar',activeSidebar)
};


export default {
  setActiveSidebar
};



// WEBPACK FOOTER //
// ./src/store/modules/home/mutations.js